import { createContext } from "react";
import type { SelectedWorkoutLabelsContextType } from "../SelectedWorkoutLabelsProvider.types";

const SelectedWorkoutLabelsContext = createContext<SelectedWorkoutLabelsContextType | undefined>(undefined);
SelectedWorkoutLabelsContext.displayName = "SelectedWorkoutLabelsContext";

export default SelectedWorkoutLabelsContext;
